import React  , {useState, useEffect} from "react";
import { useDispatch ,useSelector} from "react-redux";

import { queryClient } from '../../state/queryClient';
import { useAllContrats ,useCommerciaux } from "../../state/reactquery";
import { useUser, useEquipes , useUsers,useEquipesManagers } from "../../state/reactquery";
import { defineContratchange ,modifyDisplaymodal , definecontratsdate1 , definecontratsdate2 } from '../../state/redux';

import { axios_clients_searchclientbyid } from "../../axios/axios_clients";

import {definejsonequipes, filterscontrats , jsonlistedates} from "../../utils/gestion";
import { handlephone } from "../../utils/phone";
import { addEltHistory } from "../../state/reactquery";

import tel from '../../images/tel.svg';
import emailing from '../../images/emailing.svg';


import CalendarTwoPickers from "../../Components/Calendar/CalendarTwoPickers";
import PopupReassigner from "../../Components/Popup/PopupReassigner";
import PopupChangeStatutContrat from "../../Components/Popup/PopupChangeStatutContrat";
import PopupChangeCommissionCompagnie from "../../Components/Popup/PopupChangeCommissionCompagnie";
import WindowMail from "../../Components/Email/WindowMail";


import './EcranGestionContrats.scss';

const classNames = require('classnames');
function EcranGestionContrats(){
    const dispatch= useDispatch();
    const {date1,date2} = useSelector(state=>state.gestioncontrats);
    const jsongammesbulletins= useSelector(state=>state.courtier.jsongammesbulletins) ;
    const compagnies = Object.keys(jsongammesbulletins)
    const [dates,setDates] =  useState({date1,date2}) ;
 
    const {data:user} = useUser(localStorage.getItem('token'))  ;
    const {data:users} = useUsers(user?.courtier) ;
    const {data:equipes} = useEquipes(user?.courtier)  ;
    const {data:commerciaux} = useCommerciaux() ;
    const {data:contrats}  = useAllContrats(date1,date2) ; 
    const listeidadminsmanagers = users?.filter(u=>u.role==='ADMIN' || u.role==='MANAGER')?.map(x=>x.id)||[] ;
    const {data:equipes_managers} = useEquipesManagers(listeidadminsmanagers)  ;
    const degrerole = user?.role ==="COMMERCIAL"?1:user?.role ==="MANAGER"?2:user?.role ==="GESTION"?3:user?.role ==="ADMIN"?4:5 ;
    
    const [choicedate, setChoicedate] = useState("thismonth") ;
    const [choicecompagnie, setChoicecompagnie] =  useState('allcomps') ;
    const [choicegroupe, setchoicegroupe] =  useState('allcommerciaux') ;
    
    const [showpopupreassigner, setShowpopupreassigner] = useState(false);
    const [showpopupchangestatut, setShowpopupchangestatut] = useState(false);
    const [showpopupchangecommissioncompagnie, setShowpopupchangecommissioncompagnie] = useState(false);

    const [checkall, setCheckall]  = useState(false) ;  
    const [jsonidchange,setJsonidchange] = useState([]);

    const [displaytwocalendars, setDisplaytwocalendars] =  useState(false) ;
    const [gosearch,setGosearch] =  useState(false) ;
   
    const [showcompagnies, setShowcopmpagnies] =  useState(false) ;
    const [showcommerciaux, setShowcommerciaux] =  useState(false) ;
    const [showequipes, setShowequipes] =  useState(false) ;
    const [filters, setFilters] = useState({'compagnies':'allcomps','commerciaux':commerciaux});
    const [affcontrats,setAffcontrats]=  useState(contrats) ;
    const [choiceliste,setChoiceliste]=  useState('choiceencours') ;
    const [showpopupmail, setShowpopupmail] =  useState(false) ;
    const [leadactu, setLeadactu] =  useState({}) ;

    const jsoncontrats = {
        "choiceimpayes":affcontrats?.filter(x=>x.etat_contrat?.includes('impaye')),
        "choiceattentedocuments":affcontrats?.filter(x=>x.etat_contrat==='attentedocuments'),
        "choiceencours":affcontrats?.filter(x=>x.etat_contrat==='encours'),
        "choiceresiliesradies":affcontrats?.filter(x=>x.etat_contrat?.includes('resilie') || x.etat_contrat?.includes('radiation')),
        "choiceattentesignature':": affcontrats?.filter(x=>x.etat_contrat==='attentesignature' )
    }

    let jsonequipes =definejsonequipes(equipes,users,equipes_managers);

   const definedatesandseach= (date1,date2)=>{

        dispatch(definecontratsdate1(date1));
        dispatch(definecontratsdate2(date2));
        queryClient.invalidateQueries({queryKey: ['allcontrats',date1, date2]}) ;
        setDisplaytwocalendars(false) ; 
   }

    useEffect(()=>{  gosearch && definedatesandseach(dates.date1,dates.date2) ;},[gosearch]);

    useEffect(()=>{setAffcontrats(filterscontrats(contrats,{'compagnies':'allcomps','commerciaux':commerciaux}))},[contrats])

    const clickall = ()=>{setCheckall(!checkall); 
                            const newjsonidchangecheckall = checkall?[]:jsoncontrats[choiceliste].map(x=>{return {indexe:x.indexe, id_lead:x.id_lead}});
                            setJsonidchange(newjsonidchangecheckall) ;
    }

    const clickcheckbox = (e) => {
        setJsonidchange((prevSelected) => {
            if (!prevSelected.map(x=>x.indexe).includes(parseInt(e.target.id))) {
                return [...prevSelected, {indexe:parseInt(e.target.id) , id_lead:e.target.name}]; 
            }else { return prevSelected.filter((current) => current.indexe !== parseInt(e.target.id));}
        });
    };

    const clickchoicedate = (e)=>{ 
        setChoicedate(e.target.id) ;
        if(e.target.id!=='choicefromcal'){
            definedatesandseach(jsonlistedates[e.target.id]?.[0],jsonlistedates[e.target.id]?.[1])
        }else{setDisplaytwocalendars(!displaytwocalendars) }

    }  

    const clickchoicecomp = (e)=>{ 
      
       if(e.target.id==='allcomps'){setFilters({...filters, 'compagnies':'allcomps'}) ;
                                    setAffcontrats(filterscontrats(contrats,{...filters, 'compagnies':'allcomps'})) ;
      }
       setChoicecompagnie(e.target.id);  
       e.target.id==='selectcomp' ? setShowcopmpagnies(!showcompagnies)  : setShowcopmpagnies(false)  ;
   }  


    const filterbycompagnie = (e)=>{setFilters({...filters,'compagnies':e.target.id}) ;
                                    setAffcontrats(filterscontrats(contrats,{...filters,'compagnies':e.target.id})); 
                                    setShowcopmpagnies(false) }  ;

    const filterbycommercial = (e)=>{setFilters({...filters,'commerciaux':[e.target.id]}) ;
                                    setAffcontrats(filterscontrats(contrats,{...filters,'commerciaux':[e.target.id]}));
                                    setShowcommerciaux(false) }  ;

    const filterbyequipe = (eq) =>{setFilters({...filters,'commerciaux':jsonequipes[eq.id]}) ;
                                  setAffcontrats(filterscontrats(contrats,{...filters,'commerciaux':jsonequipes[eq.id]}));
                                   setShowequipes(false)}

    const clickchoicegroupe = (e)=>{
       setchoicegroupe(e.target.id);
       e.target.id==='allcommerciaux' && setFilters({...filters,'commerciaux':users.map(x=>x.nom)}) ;
       e.target.id==='allcommerciaux' && setAffcontrats(filterscontrats(contrats,{...filters,'commerciaux':users.map(x=>x.nom)})) ;
       e.target.id==='selectcommercial' ? setShowcommerciaux(!showcommerciaux)  : setShowcommerciaux(false)  ;
       e.target.id==='selectequipe' ? setShowequipes(!showequipes)  : setShowequipes(false)  ;
   }  
    

const choiceleads = (e)=>{   setChoiceliste(e.target.id) ;}

const choice =(id,titre,nb)=>( <div  id={id} className={classNames(`ecrangestionfilterleads_btn ${id}`,{"selected":choiceliste===id})} onClick={choiceleads} >
                                        <div className={classNames("ecrangestionfilterleads_btn_titre",{"selected":choiceliste===id})}>{titre}</div>
                                        <div className={classNames("ecrangestionfilterleads_btn_nb",{"selected":choiceliste===id})}>{nb}</div>
                                   </div>) ;

                                   
const clickline = (e,contrat)=>{ if(e.target?.classList.contains('noclickline')){return }
     dispatch(defineContratchange(contrat))  ;dispatch(modifyDisplaymodal('mod_modifcontrat'));
}



const linecontrat = (x)=>(<div key={x.indexe} className="gestioncontrats_tablo_line cursorpointer"  onClick={(e)=>clickline(e,x)} >
                            <div className="noclickline">
                                <input type="checkbox" id={x.indexe} name={x.id_lead} className={classNames("noclickline gestionleads_checkbox", { 'checked': jsonidchange?.map(x=>x.indexe).includes(x.indexe) })}  onClick={clickcheckbox} />
                            </div>
                            <div>{x.nom_titulaire} {x.prenom_titulaire}</div>
                            <div>{x.commercial}</div>
                            <div>{new Date(x.date_signature).toLocaleDateString('fr-FR')}</div>
                            <div>{x.date_effet}</div>
                            <div>{x.compagnie}</div>
                            <div>{parseFloat((x.prix*12)?.toFixed(2))} €</div>
                            <div>{x.etat_contrat}</div>
                            <div>{x.commission_compagnie===1?'Oui':'Non'}</div>
                            <div className="noclickline"> 
                                <img  className="noclickline" src={tel} height="18" alt="imgtel" onClick={()=>clicktel(x.id_lead)}  />
                            </div>
                            <div className="noclickline"> 
                                <img  className="noclickline" src={emailing} height="23" alt="imgemail" onClick={()=>clickmail(x.id_lead)}  />
                            </div>
                        </div>) ;
    const convertdate = (date)=>{ return (new Date(date)).toLocaleString("fr-FR",{timeZone:"Europe/Paris"})}
    
    const contratline = (c)=>[c.nom_titulaire+' '+c.prenom_titulaire,c.email,c.telephone,convertdate(c.date_effet),c.commercial,c.etat_contrat,c.num_contrat] ;    

    const listetocsv = async(contrats)=>{
        let csvString = [["Nom / Prénom","Email","Téléphone","Date d'effet","Commercial","Statut","Nume de contrat"]] ;
        contrats.forEach(item=>csvString.push(contratline(item)));
        var hiddenElement = document.createElement('a');  
        hiddenElement.href='data:text/csv;charset=utf-8,'+encodeURI(csvString.map(line => line.join(",")).join("\n"));
        hiddenElement.target='_blank';
        hiddenElement.download =`${choiceliste}${(new Date()).toISOString()}.csv`;  
        hiddenElement.click(); 
    }

    const popupreassigner = ()=>{  setShowpopupreassigner(true) ; }

    const clicktel = async(idlead)=>{ addEltHistory(idlead ,'appelsortant',`<div class='horoline1' >Appel sortant par ${user.firstname} ${user.lastname} </div>` ) ;
                                     const reqclient = await axios_clients_searchclientbyid(idlead) ;    
                                    handlephone(reqclient?.data?.telephone) ;  }
    
    const clickmail = async(idlead)=>{
              const reqclient = await axios_clients_searchclientbyid(idlead) ;  
              setLeadactu(reqclient.data) ;    
              setShowpopupmail(true);
      }


    return(<>
            {showpopupmail &&  <div className="ecrangestioncontratssendemail" >
                            <WindowMail emailTo={leadactu.email}  leadactu={leadactu} closewindow={()=>setShowpopupmail(false)}  /> 
                               </div>}
            {showpopupreassigner && <PopupReassigner setShowpopupreassigner={setShowpopupreassigner} listidchangecom={jsonidchange?.map(x=>x.id_lead)}  setListidchange={setJsonidchange}   /> }
             {showpopupchangestatut && <PopupChangeStatutContrat setShowpopupchangestatut={setShowpopupchangestatut} listidchangestatut={jsonidchange?.map(x=>x.indexe)}  setListidchange={setJsonidchange} dates={dates} /> }
             {showpopupchangecommissioncompagnie && <PopupChangeCommissionCompagnie setShowpopupchangecommissioncompagnie={setShowpopupchangecommissioncompagnie} listidchangestatut={jsonidchange?.map(x=>x.indexe)} setListidchange={setJsonidchange} dates={dates} /> }
          
                <div className="ecrangestionfilterssearch">    
                    <div className="grpbtnstimes">
                        <button id="today"  onClick={clickchoicedate} className={classNames("btnchoice",{'first':true},{'last':false},{'selected':choicedate==="today"})} >Ajourd.</button>
                        <button id="lastweek" onClick={clickchoicedate} className={classNames("btnchoice",{'first':false},{'last':false},{'selected':choicedate==="lastweek"})} >Semaine Prec.</button>
                        <button id="thismonth" onClick={clickchoicedate} className={classNames("btnchoice",{'first':false},{'last':false},{'selected':choicedate==="thismonth"})} >Ce mois-ci</button>
                        <button id="lastmonth" onClick={clickchoicedate} className={classNames("btnchoice",{'first':false},{'last':false},{'selected':choicedate==="lastmonth"})} >Mois dern.</button>
                        <button id="choicefromcal" onClick={clickchoicedate} className={classNames("btnchoice",{'first':false},{'last':true},{'selected':choicedate==="choicefromcal"})} >Choisir dates</button>
                        {displaytwocalendars &&  <div className="containertwocalendars" >  <CalendarTwoPickers filtres={dates} setFiltres={setDates} setDisplaytwocalendars={setDisplaytwocalendars}   setGosearch={setGosearch} /> </div>   }
                    </div>

                    <div className="container_origines" >
                        {showcompagnies && <div className="origines" >{compagnies.map(o=><div className="origine"   key={o} id={o} onClick={filterbycompagnie}  >{o} </div> )}</div>}
                        <button id="allcomps" onClick={clickchoicecomp} className={classNames("btnchoice",{'first':true},{'last':false},{'selected':choicecompagnie==="allcomps"})} >Toutes comp.</button>
                        <button id="selectcomp" onClick={clickchoicecomp}  className={classNames("btnchoice",{'first':false},{'last':true},{'selected':choicecompagnie==="selectcomp"})} > {filters.compagnies==='allcomps' ?'Choisir comp.':filters.compagnies}</button>                                                                                                                                
                    </div>
                    <div className="container_origines">
                        {showcommerciaux && <div className="origines" >{[...commerciaux]?.sort().map(o=><div className="origine"   key={o} id={o} onClick={filterbycommercial}  >{o} </div> )}</div>}
                        {showequipes && <div className="divequipes" >{equipes?.map(eq=><div className="origine"   key={eq.id} id={eq.id} onClick={()=>filterbyequipe(eq)}  >{eq.nom} </div> )}</div>}
                        {user?.role ==='MANAGER'?<><button id="allcommerciaux"  onClick={clickchoicegroupe} className={classNames("btnchoice",{'first':true},{'last':false},{'selected':choicegroupe==="allcommerciaux"})} >Equipe</button>
                                                    <button id="selectcommercial"   onClick={clickchoicegroupe}  className={classNames("btnchoice",{'first':false},{'last':true},{'selected':choicegroupe==="selectcommercial"})} >{filters.commerciaux?.length!==1?'Par conseiller':filters.commerciaux} </button>                                                               
                                                </>:<><button id="allcommerciaux"  onClick={clickchoicegroupe} className={classNames("btnchoice",{'first':true},{'last':false},{'selected':choicegroupe==="allcommerciaux"})} >Tout le cabin.</button>
                                                    <button id="selectequipe"  onClick={clickchoicegroupe}  className={classNames("btnchoice",{'first':false},{'last':false},{'selected':choicegroupe==="selectequipe"})} >Par équipe</button>
                                                    <button id="selectcommercial"   onClick={clickchoicegroupe}  className={classNames("btnchoice",{'first':false},{'last':true},{'selected':choicegroupe==="selectcommercial"})} >{filters.commerciaux?.length!==1?'Par conseiller':filters.commerciaux} </button></>}                                          
                    </div>
                </div>
                <div className="ecrangestionfilterleads">
                        {choice("choiceencours","Contrats signés",jsoncontrats["choiceencours"]?.length)}
                        {choice("choiceattentesignature':","Attente Signature",jsoncontrats["choiceattentesignature':"]?.length)}
                        {choice("choiceattentedocuments","Documents en atente",jsoncontrats["choiceattentedocuments"]?.length)}
                        {choice("choiceimpayes","Contrats Impayés",jsoncontrats["choiceimpayes"]?.length)}
                        {choice("choiceresiliesradies","Contrats Resiliés ou Radiés",jsoncontrats["choiceresiliesradies"]?.length)}
                    </div>
                <div  className="gestioncontrats">
                            <div  className="gestioncontrats_top">
                                <div><input type="checkbox"  className={classNames("gestionleads_checkbox",{'checked':checkall})}  onClick={clickall} /></div>
                                <div>Nom & Prénom</div><div>Commercial</div><div>Date de signature</div>
                                <div>Date d'effet</div><div>Compagnie</div><div>Prime annuelle</div>
                                <div>Etat du Contrat</div><div>Commission</div><div></div>
                            </div>   
                            <div  id="madivscroll"  className="gestionleads_tablo">
                                <div id="contentscroll"> {contrats?.length > 0 && jsoncontrats[choiceliste]?.map((x)=>linecontrat(x)) }</div>
                            </div>  
               </div>
               <div className="grpbtnflex">
                    <div className="exportcsv"  onClick={()=>listetocsv(jsoncontrats[choiceliste])} >Exporter CSV</div>
                    { degrerole >1  && <div className="reassigner"  onClick={()=>{jsonidchange?.length > 0 && popupreassigner()}} >Ré-assigner</div> }
                    { (degrerole >2 || user.email==='eric@groupefidelis.com') && <div className="reassigner"  onClick={()=>{jsonidchange?.length > 0 && setShowpopupchangestatut(true)}} >Modification Statut</div> }
                    { (degrerole >2 || user.email==='eric@groupefidelis.com') && <div className="reassigner"  onClick={()=>{jsonidchange?.length > 0 && setShowpopupchangecommissioncompagnie(true)}} >Modification Commission</div> }
                </div>
           

               </>
    )
}


export default EcranGestionContrats  ; 